import type { BossConfig } from '../../entities/BossConfig';

export const CAMEL_CONFIG: BossConfig = {
  id: 'camel',
  displayName: 'Заражённый Верблюд',
  bossType: 'charging',

  // Мини-босс — НЕ толще главных. Меньше Медведя (250) и Лося (100×). Старт 140, калибровка.
  maxHp: 140,
  speed: 0,
  movementBehavior: 'charging_boss',

  chargingParams: {
    idleMs: 1600,
    // Телеграф: плевок → пауза → рывок. Снаряд спавнится в начале windup,
    // далее windupMs тикает до перехода в charge — ровно длина паузы.
    windupMs: 500,
    chargeSpeed: 430,
    recoveryMs: 1100,
    contactDamage: 0,
  },

  contactBehavior: 'instakill',
  instakillDragMs: 400,

  // Неуязвим в фазе charge — пули отскакивают, зелёный glow по контуру
  // (та же логика что у лося, через Boss.applyInvulnerableGlow).
  invulnerableInPhases: ['charge'],

  // Run-spritesheet 4 кадра играет только на charge. В покое (idle/windup/
  // recovery) — стоп-кадр (никакого "бега на месте", как у лося/медоеда).
  // Origin (0.5, 1) — ноги по низу.
  animateOnlyOnCharge: true,
  spriteOrigin: [0.5, 1],

  // Плевок — анимированный спрайт camel_spit (3 кадра, крутится в полёте).
  // Спавнится у "пасти" (mouthOffset, signed по chargeDirX), летит строго
  // горизонтально (horizontalOnly: true). Эффект — замедление 45% на 2.5с.
  // projectileSize — РАДИУС КОЛЛИЗИИ (14px), не визуальный размер. Визуал
  // через spriteHeightPx=40 (sprite ~110×40 на 720p, заметный сгусток).
  // projectileColor игнорируется при наличии textureKey, оставлен fallback'ом.
  projectileAttack: {
    enabled: true,
    throwInPhase: 'windup',
    projectileSpeed: 1000,
    projectileSize: 14,
    projectileColor: 0x9acd32,
    blockDurationMs: 2500,
    throwEveryNthCycle: 1,
    effectType: 'slow',
    slowFactor: 0.45,
    textureKey: 'camel_spit',
    animKey: 'camel_spit',
    spriteHeightPx: 40,
    mouthOffsetX: 70,
    mouthOffsetY: -20,
    horizontalOnly: true,
  },

  size: 52,
  color: 0xc2a878,

  phaseTints: {
    idle: 0xc2a878,
    windup: 0xd4b886,
    charge: 0xb8943f,
    recovery: 0xa89060,
  },

  scoreReward: 900,
};
